import { Injectable } from '@angular/core';
/*import {
  Http,
  //Request,
  //RequestMethod,
  Response
}  from "@angular/http";*/
import { Observable } from 'rxjs';
import { HttpClient, HttpRequest, HttpEventType } from '@angular/common/http';
import { PJ } from '../data/pj';
import { Image } from '../data/image';
import { Webcam } from '../data/webcam';
import { RandoObject } from '../data/rando-object';
import { MapLayer } from '../data/map-layer';
import { MapCluster } from '../data/map-cluster';
import { BoundingBox } from '../data/bounding-box';
import { AuthCredentials } from '../data/auth-credentials';
import { AuthRegister } from '../data/auth-register';
import { ToolsGPXData } from '../data/tools-gpx-data';
import { ToolsGPXStats } from '../data/tools-gpx-stats';
import { PJDuplicates } from 'app/shared/data/pjDuplicates';
import { PJDuplicate } from 'app/shared/data/pjDuplicate';
import { PJDTO } from 'app/shared/services/data/PJDTO';
import { Stats } from '../data/stats';
import { Note } from '../data/note';
import { NoteDTO } from 'app/shared/services/data/NoteDTO';

const WS_URL = "https://www.randonneurs.ch/RandoV3/services";

/*
The CORS specification distinguishes two distinct use cases:

Simple requests. This use case applies if we use HTTP GET, HEAD and POST methods. In the case of POST methods, only content types with the following values are supported:
/plain, application/x-www-form-urlencoded and multipart/form-data.
Preflighted requests. When the ‘simple requests’ use case doesn’t apply, a first request (with the HTTP OPTIONS method) is made to check what can be done in the context of cross-domain requests.
*/


@Injectable()
export class RandonneursService {

  constructor(
    protected http: HttpClient
  ) { }


  // ============================================================================================================================================
  // Security

  public login(credentials: AuthCredentials): Observable<AuthCredentials> {
    return this.http.post<AuthCredentials>(WS_URL+"/login", credentials, {
      // Otherwise OPTIONS is sent (CORS)
      'headers':{'Content-Type': 'application/x-www-form-urlencoded'}
    });
  }

  public register(data: AuthRegister) {
    return this.http
      .post(WS_URL+"/register", data, {
        'headers':{'Content-Type': 'application/x-www-form-urlencoded'}
      });
  }

  public confirmid(code: String) {
    return this.http
      .post(WS_URL+"/confirmid", code, {
        'headers':{'Content-Type': 'application/x-www-form-urlencoded'}
      });
  }


  // ============================================================================================================================================


  public toolsGPX(data: ToolsGPXData): Observable<ToolsGPXStats> {
    return this.http.post<String>(WS_URL+"/geo/elevation_from_tools_gpx2", data, {
      // Otherwise OPTIONS is sent (CORS)
      //'headers':{'Content-Type': 'application/json'}
      //'headers':{'Content-Type': 'application/x-www-form-urlencoded'}
      //'headers':{'Content-Type': 'multipart/form-data'}

      'headers':{
          //'Content':"application/json",
          'Content-Type':"application/x-www-form-urlencoded"
      }
    }).map(x=>this.mapGPXFileData(x));
  }

  private mapGPXFileData(x): ToolsGPXStats {
    return new ToolsGPXStats(x['dist'], x['distEffort'],
      x['sumElePos'], x['sumEleNeg'], x['data']);
  }


  /*public toolsGPX(b64Data: string): Observable<String> {
    console.log("Randonneurs-service: sending post");
    return this.http.post<String>(WS_URL+"/tools/gpx2", b64Data, {
      // Otherwise OPTIONS is sent (CORS)
      'headers':{'Content-Type': 'text/plain; charset=UTF-8'}
    });*/

    /*const req = new HttpRequest('POST', 'upload/file', b64Data, {
    });
    this.http.request(req)
      .subscribe(event => {
        if (event.type === HttpEventType.UploadProgress) {
          console.log(event.total, event.loaded);
        } else if (event.type === HttpEventType.Response) {
          return event.body
        }
      });
}*/

  // ============================================================================================================================================
  // PJ

  public getPJList(boundingBox: BoundingBox, nb?:Number, missingName?:boolean) : Observable<Array<PJ>> {
    if (nb==null) nb=500;
    let url = WS_URL + "/pj?" + this.mapBBoxURL(boundingBox); //&clusterMinPoints=30&clusterMaxPoints=50";
    url = url + "&nb=" + (nb==null?500:nb);
    url = url + (missingName!=null && missingName==true?"&missingName=1":"");
    console.log(`Calling ${url}`);
    return this.http
        .get(url)
        .map(data => this.mapPJArray(data));
  }

  public getPJ(boundingBox: BoundingBox) : Observable<MapLayer> {
    let url = WS_URL + "/pj?" + this.mapBBoxURL(boundingBox) + "&nb=500";//"&nb=200&clusterMinPoints=30&clusterMaxPoints=50";
    console.log(`Calling ${url}`);
    return this.http
      .get(url)
      .map(data => this.mapPJMapLayer(data));
  }

  public getPJDuplicates(start:number, limit:number) : Observable<PJDuplicates> {
    let url = WS_URL + "/pj/duplicates?start="+start+"&limit="+limit;
    console.log(`Calling ${url}`);
    return this.http
      .get(url)
      .map(data => this.mapPJDuplicates(data));
  }

  public getPJById(idPj: number) : Observable<PJ> {
    let url=WS_URL + "/pj/"+idPj;
    console.log(`Calling ${url}`);
    return this.http
      .get(url)
      .map(pj => this.mapPJ(pj));
  }


  public deletePJ(idPj: number) : Observable<String> {
    let url=WS_URL + "/pj/"+idPj;
    console.log(`Calling DELETE ${url}`);
    return this.http
      .delete(url)
      .map(success => 'OK');
  }

  public rotateLeftPJ(idPj: number) : Observable<String> {
    let url=WS_URL + "/pj/"+idPj+'/rotateLeft';
    console.log(`Calling ${url}`);
    return this.http
      .put(url, '[]', {
        // Otherwise OPTIONS is sent (CORS)
        'headers':{'Content-Type': 'application/x-www-form-urlencoded'}
      })
      .map(success => 'OK');
  }

  public rotateRightPJ(idPj: number) : Observable<String> {
    let url=WS_URL + "/pj/"+idPj+'/rotateRight';
    console.log(`Calling ${url}`);
    return this.http
      .put(url, '[]', {
        // Otherwise OPTIONS is sent (CORS)
        'headers':{'Content-Type': 'application/x-www-form-urlencoded'}
      })
      .map(success => 'OK');
  }

  public updatePJ(pj: PJ) : Observable<String> {
    let url=WS_URL + "/pj";
    let dto = PJDTO.build(pj);
    console.log(`Calling ${url} for pj ` + pj.id, dto);

    return this.http.put(url,dto, {
        // Otherwise OPTIONS is sent (CORS)
        'headers':{'Content-Type': 'application/x-www-form-urlencoded'}
      })
      .map(success => 'OK');
  }


  // ============================================================================================================================================
  // Notes

  public getNotesList() : Observable<Array<Note>> {
    let url = WS_URL + "/note/all";
    console.log(`Calling ${url}`);
    return this.http
        .get(url)
        .map(data => this.mapNoteArray(data));
  }

  public createNote(note: Note) : Observable<String> {
    let url=WS_URL + "/note";
    let dto = NoteDTO.build(note);
    console.log(`Calling ${url} for note ` + note.id, dto);

    return this.http.post(url,dto, {
        // Otherwise OPTIONS is sent (CORS)
        'headers':{'Content-Type': 'application/x-www-form-urlencoded'}
      })
      .map(success => 'OK');
  }


  public updateNote(note: Note) : Observable<String> {
    let url=WS_URL + "/note";
    let dto = NoteDTO.build(note);
    console.log(`Calling ${url} for note ` + note.id, dto);

    return this.http.put(url,dto, {
        // Otherwise OPTIONS is sent (CORS)
        'headers':{'Content-Type': 'application/x-www-form-urlencoded'}
      })
      .map(success => 'OK');
  }


  public deleteNote(idNote: number) : Observable<String> {
    let url=WS_URL + "/note/"+idNote;
    console.log(`Calling DELETE ${url}`);
    return this.http
      .delete(url)
      .map(success => 'OK');
  }



  // ============================================================================================================================================
  // Images

  public getImages(boundingBox: BoundingBox) : Observable<MapLayer> {
    let url = WS_URL + "/image?" + this.mapBBoxURL(boundingBox)  +"&nb=500";// "&nb=100&clusterMinPoints=30&clusterMaxPoints=50";
    console.log(`Calling ${url}`);
    return this.http
      .get(url)
      .map(data => this.mapImageMapLayer(data));
  }

  public getImageById(idImage: string) : Observable<Image> {
    let url=WS_URL + "/image/"+idImage;
    console.log(`Calling ${url}`);
    return this.http
      .get(url)
      .map(i => this.mapImage(i));
  }


  // ============================================================================================================================================
  // Objects

  public getObjects(boundingBox: BoundingBox) : Observable<MapLayer> {
    let url = WS_URL + "/object?" + this.mapBBoxURL(boundingBox)  +"&nb=500";// "&nb=100&clusterMinPoints=30&clusterMaxPoints=50";
    console.log(`Calling ${url}`);
    return this.http
      .get(url)
      .map(data => this.mapObjectMapLayer(data));
  }

  public getObjectById(id: string) : Observable<RandoObject> {
    let url=WS_URL + "/object/"+id;
    console.log(`Calling ${url}`);
    return this.http
      .get(url)
      .map(i => this.mapObject(i));
  }


  // ============================================================================================================================================
  // Webcams

  public getWebcams(boundingBox: BoundingBox) : Observable<MapLayer> {
    let url = WS_URL + "/webcam/search?" + this.mapBBoxURL(boundingBox)  +  "&nb=500";//&nb=500&clusterMinPoints=30&clusterMaxPoints=50";
    console.log(`Calling ${url}`);
    return this.http
      .get(url)
      .map(data => this.mapWebcamMapLayer(data));
  }

  public getWebcamById(idWebcam: number) : Observable<Webcam> {
    let url = WS_URL + "/webcam/" + idWebcam;
    console.log(`Calling ${url}`);
    return this.http
      .get(url)
      .map(cam => this.mapWebcam(cam));
  }


  // ============================================================================================================================================
  // Various

  public getStats() : Observable<Stats> {
    let url = WS_URL + "/stats";
    console.log(`Calling ${url}`);
    return this.http
      .get(url)
      .map(res => this.mapStats(res));
  }

  public geolocate(q: string): Observable<number[]> {
    let url = "https://nominatim.openstreetmap.org/search/" + q + "?countrycodes=CH&format=json&limit=1";
    return this.http.get(url).map(res => {
      let res2 = res[0];
      // TODO: if length is zero return null
      let tlon:number=res2["lon"];
      let tlat:number=res2["lat"];
      return [tlon, tlat];
    });
  }



  // ============================================================================================================================================
  // Mappers

  private mapBBoxURL(boundingBox: BoundingBox) {
    return "lonMin=" + boundingBox.lonMin + "&latMin=" + boundingBox.latMin + "&lonMax=" + boundingBox.lonMax + "&latMax=" + boundingBox.latMax;
  }

  private mapCluster(obj:Object[]): MapCluster[] {
    if (obj==null) {
      return [];
    }
    return obj.map(cluster => new MapCluster(cluster["size"], cluster["clon"], cluster["clat"]));
  }

  private mapPJ(pj): PJ {
    return new PJ(pj["idPJ"], Number(pj["longitude"]), Number(pj["latitude"]), Number(pj["altitude"]),
        pj["content"], pj["nom"], pj["tmbImg"], pj["bigImg"]);
  }

  private mapNote(note): Note {
    return new Note(note["idnote"],note["ispublic"],note["title"],note["description"],note["loctitle"],note["loclon"],note["loclat"],note["localt"],
        note["datefrom"],note["dateto"],note["urlimage"],note["urllink"],note["source"]);
  }

  private mapWebcam(cam): Webcam {
    return new Webcam(cam["idWebcam"], Number(cam["longitude"]), Number(cam["latitude"]), Number(cam["altitude"]),
        Number(cam["azimuth"]), cam["title"], cam["urlimage"], cam["urltopic"], cam["urlsource"]);
    // TODO: donner l'URL complète
  }

  private mapStats(res): Stats {
    console.log("mapStats got ", res);
    return new Stats(Number(res["NB_ALBUMS"]), Number(res["NB_IMAGES"]), Number(res["NB_PJS"]), Number(res["NB_WEBCAMS"]), Number(res["NB_OBJECTS"]));
  }

  private mapImage(img): Image {
    return new Image(img["idImage"], Number(img["longitude"]), Number(img["latitude"]), Number(img["altitude"]),
        img["title"], img["description"], img["datetime"], img["fkAlbum"]);
  }

  private mapObject(obj): RandoObject {
    return new RandoObject(obj["idObject"], obj["type"], obj["title"], Number(obj["longitude"]), Number(obj["latitude"]), Number(obj["altitude"]),
        obj["url"], obj["text"]);
  }

  private mapPJMapLayer(data): MapLayer {
      // TODO: donner l'URL complète
    let pjList = (<Object[]>data["pjs"]).map(pj => this.mapPJ(pj));
    let cluster = this.mapCluster(data["cluster"]);
    return new MapLayer(pjList, cluster, true);
  }

  private mapPJArray(data): Array<PJ> {
    return (<Object[]>data["pjs"]).map(pj => this.mapPJ(pj));
  }

  private mapPJDuplicates(data): PJDuplicates {
    console.log("DBG1", data);
    let duplicates = new PJDuplicates(data['count'], data['start'], data['limit'], this.mapPJArrayDuplicate(data['duplicates']));
    return duplicates;
  }

  private mapPJArrayDuplicate(data): Array<PJDuplicate> {
    let arr = new Array();
    let pjList = (<Object[]>data).map(dup => {
      let ret = new PJDuplicate(this.mapPJ(dup["pj1"]), this.mapPJ(dup["pj2"]));
      arr.push(ret);
    });
    return arr;
  }

  private mapNoteArray(data): Array<Note> {
    return (<Object[]>data).map(note => this.mapNote(note));
  }

  private mapWebcamMapLayer(data): MapLayer {
    let camList = (<Object[]>data["webcams"]).map(cam => this.mapWebcam(cam));
    let cluster = this.mapCluster(data["cluster"]);
    return new MapLayer(camList, cluster, true);
  }

  private mapImageMapLayer(data): MapLayer {
    let imgList = (<Object[]>data["images"]).map(img => this.mapImage(img));
    let cluster = this.mapCluster(data["cluster"]);
    return new MapLayer(imgList, cluster, true);
  }

  private mapObjectMapLayer(data): MapLayer {
    let list = (<Object[]>data["objects"]).map(cam => this.mapObject(cam));
    let cluster = this.mapCluster(data["cluster"]);
    return new MapLayer(list, cluster, true);
  }

}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/randonneurs-2018-build-and-to-local/src/app/shared/services/randonneurs.service.ts